import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: '#7833FF',
  },
  secondaryColor: {
    color: '#D6246E',
  },
  mainTablePricing: {
    boxShadow: '0px 3px 6px #00000029',
    borderRadius: '10px 10px 0px 0px',
  },
  mainDescribePrice: {
    boxShadow: '0px 3px 6px #00000029',
    borderRadius: '0px 0px 10px 10px',
    borderTop: '2px solid #C9C9C9',
  },
  button: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    borderRadius: 40,
    backgroundColor: '#7833FF',

    '&:hover': {
      backgroundColor: '#5F29CC',
    },
  },
  sectionImage: {
    display: 'block',
    margin: '0 auto',
    maxWidth: '100%',
  },
  titleContent: {
    fontSize: 16,
    margin: 0,
    color: '#7833FF',
    fontWeight: 'Bold',
    marginBottom: theme.spacing(1),
  },
  title: {
    color: '#7833FF',
    fontSize: 28,
    fontFamily: 'Lato',
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(4),
  },
  sectionImageGraphicalAbstract: {
    [theme.breakpoints.up('md')]: {
      height: 400,
    },
  },
  dividerPrice: {
    margin: theme.spacing(2, 4),
  },
  titleFree: {
    fontSize: 45,
    color: '#7833FF',
    margin: theme.spacing(3.5, 0),
  },
  buttonWhite: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #9E9E9E',
    borderRadius: 35,
    color: '#616161',
    padding: theme.spacing(1.5, 3),

    '&:hover': {
      border: '1px solid #7833FF',
      color: '#7833FF',
      backgroundColor: '#FAFAFA',
    },
  },
  gridPrice: {
    borderRight: '1px solid #E5E5E5',
  },
  infoPrice: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    marginTop: theme.spacing(3),
    gap: 4,
  },
  badge: {
    display: 'inline-block',
    padding: theme.spacing(0.5, 1),
    fontSize: theme.typography.overline.fontSize,
    backgroundColor: theme.palette.grey[100],
    border: `1px solid ${theme.palette.grey[400]}`,
    marginBottom: theme.spacing(2),
    cursor: 'pointer',
  },
  buttonPink: {
    backgroundColor: '#D6246E',
    borderRadius: 35,
    color: '#FFFFFF',
    padding: theme.spacing(1.5, 3),

    '&:hover': {
      backgroundColor: '#BC1A5D',
    },
  },
  list: {
    paddingInlineStart: '40px',
    color: theme.palette.grey[300],

    '& li': {
      marginBottom: theme.spacing(1.5),
      paddingRight: theme.spacing(2),
    },

    '& span': {
      fontSize: 12,
      color: theme.palette.text.primary,
    },
  },
  dividerDescribePrice: {
    margin: theme.spacing(1, 2, 2),
  },
  contentTextPrice: {
    marginLeft: theme.spacing(3),
    gap: 7,
    display: 'grid',
  },
  gridTextInfo: {
    borderRight: '1px solid #00000029',
    margin: theme.spacing(3.5, 0),

    '&:last-of-type': {
      borderRight: 'none',
    },
  },
  priceCardActiveSecondary: {
    position: 'relative',

    '&::before': {
      position: 'absolute',
      top: -88,
      left: 150,
      display: 'inline-block',
      width: 180,
      marginLeft: -90,
      padding: theme.spacing(2, 0),
      content: '"一番人気！"',
      color: theme.palette.common.white,
      backgroundColor: '#D6246E',
      fontSize: theme.typography.h6.fontSize,
      fontWeight: theme.typography.fontWeightBold,
      textAlign: 'center',
      borderTopLeftRadius: 15,
      borderTopRightRadius: 15,
    },
  },
  mainTestimonials: {
    background: 'linear-gradient(0deg, rgba(238,238,238,1) 90%, rgba(255,255,255,1) 90%)',
    paddingBottom: theme.spacing(5),
  },
  titleInfoPlan: {
    paddingLeft: theme.spacing(3),
  },
  priceButton: {
    backgroundColor: '#D6246E',
    color: 'white',
    borderRadius: '40px',
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '1.1rem', // Larger font size
    width: '190px', // Set minimum width
    height: '40px',
    padding: '12px 24px',
    '&:hover': {
      backgroundColor: '#D6246E',
      filter: 'brightness(0.9)',
    },
  },
}));
